import { Component, OnInit } from '@angular/core';
import { VinculacionEstadoFinancieroService } from '../../_services/vinculacion-estado-financiero.service';
import { NavService } from '../../_services/_nav.service';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Funcionalidad } from '../../_models/funcionalidad';
import { forkJoin } from 'rxjs';
import { ListaService } from '../../_services/lista.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { VinculacionEstadoFinanciero } from '../../_models/vinculacion-estado-financiero';
import { ListaItem } from '../../_models/lista-item';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component( {
  selector: 'app-configuracion-tipo-vinculacion',
  templateUrl: 'vinculacion-estado-financiero.component.html'
} )

export class VinculacionEstadoFinancieroComponent implements OnInit {

  carInformacionInicial = true;
  menu: Funcionalidad = new Funcionalidad();
  columnas: any[] = [];
  lisVinculaciones: SelectItem[] = [];
  lisVinculacionesTodos: ListaItem[] = [];
  lisVinculacionesEstadoFinanciero: VinculacionEstadoFinanciero[] = [];
  lisVinculacionesEstadoFinancieroTodos: VinculacionEstadoFinanciero[] = [];
  formulario: FormGroup;
  vinEstadoFinancieroSeleccionada: VinculacionEstadoFinanciero;
  submitted = false;
  tipVinculacionSeleccionada: ListaItem;

  constructor( private vinEstadoFinancieroServicio: VinculacionEstadoFinancieroService,
               private fb: FormBuilder,
               private conServicio: ConfirmationService,
               private navServicio: NavService, private autServicio: AutenticacionService, private lisServicio: ListaService ) {
  }

  ngOnInit(): void {

    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/vinculacion-estado-financiero' );
    if ( mn ) {
      this.menu = mn;
    }
    this.columnas = [
      { field: 'tipoVinculacion', header: this.navServicio.buscarMensaje( 'VINCULACIONESTADOFINANCIERO.LBL_VINCULACION' ), sort: true },
      { field: 'indicadorConyuge', header: this.navServicio.buscarMensaje( 'VINCULACIONESTADOFINANCIERO.LBL_CONYUGE' ), sort: true },
      {
        field: 'indicadorOtroVinculado',
        header: this.navServicio.buscarMensaje( 'VINCULACIONESTADOFINANCIERO.LBL_OTRODEUDOR' ),
        sort: true
      },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    forkJoin( this.lisServicio.getMasterDetails( 'ListasTiposVinculaciones' ), this.vinEstadoFinancieroServicio.listado() ).subscribe( ( [ lisVinculaciones, lisEstadosFinancieros ] ) => {
      this.lisVinculacionesEstadoFinancieroTodos = lisEstadosFinancieros;
      this.lisVinculacionesTodos = lisVinculaciones;
      const exiTitular = this.lisVinculacionesEstadoFinancieroTodos.find( x => x.codigoTipoVinculacion === 'TITULAR' );
      const titular = lisVinculaciones.find( x => x.codigo === 'TITULAR' );
      if ( !exiTitular && titular ) {
        const nueTitular = {} as VinculacionEstadoFinanciero;
        nueTitular.idTipoVinculacion = titular.idLista;
        nueTitular.tipoVinculacion = titular.nombre;
        nueTitular.codigoTipoVinculacion = titular.codigo;
        nueTitular.indicadorConyuge = false;
        nueTitular.indicadorOtroVinculado = false;
        nueTitular.indicadorHabilitado = true;
        this.vinEstadoFinancieroServicio.crear( nueTitular ).subscribe( registro => {
          nueTitular.idVinculacionEstadoFinanciero = registro.idVinculacionEstadoFinanciero;
          this.lisVinculacionesEstadoFinancieroTodos.push( nueTitular );
          this.cargarEstadosFinancieros();
          this.cargarTipoVinculacion();
          this.cargarFormulario();
          this.carInformacionInicial = false;
        } );
      } else {
        this.cargarEstadosFinancieros();
        this.cargarTipoVinculacion();
        this.cargarFormulario();
        this.carInformacionInicial = false;
      }
    } );
  }

  cargarEstadosFinancieros() {
    this.lisVinculacionesEstadoFinanciero = this.lisVinculacionesEstadoFinancieroTodos.filter( x => x.indicadorHabilitado );
  }

  cargarTipoVinculacion() {
    this.lisVinculaciones = [];
    this.lisVinculacionesTodos.map( ( s: ListaItem ) => {
      if ( !this.lisVinculacionesEstadoFinanciero.find( x => x.idTipoVinculacion === s.idLista ) ) {
        this.lisVinculaciones.push( { label: s.nombre, value: s.idLista } );
      }
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idVinculacionEstadoFinanciero: [ this.vinEstadoFinancieroSeleccionada ? this.vinEstadoFinancieroSeleccionada.idVinculacionEstadoFinanciero : null ],
      idTipoVinculacion: [ this.vinEstadoFinancieroSeleccionada ? this.vinEstadoFinancieroSeleccionada.idTipoVinculacion : null, [ Validators.required ] ],
      indicadorConyuge: [ this.vinEstadoFinancieroSeleccionada ? this.vinEstadoFinancieroSeleccionada.indicadorConyuge : false ],
      indicadorOtroVinculado: [ this.vinEstadoFinancieroSeleccionada ? this.vinEstadoFinancieroSeleccionada.indicadorOtroVinculado : false ],
      indicadorHabilitado: [ this.vinEstadoFinancieroSeleccionada ? this.vinEstadoFinancieroSeleccionada.indicadorHabilitado : true ],
      tipoVinculacion: [ this.vinEstadoFinancieroSeleccionada ? this.vinEstadoFinancieroSeleccionada.tipoVinculacion : null ],
      codigoTipoVinculacion: [ this.vinEstadoFinancieroSeleccionada ? this.vinEstadoFinancieroSeleccionada.codigoTipoVinculacion : null ],
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.carInformacionInicial = true;
      const registro = this.formulario.value;
      if ( this.tipVinculacionSeleccionada && this.tipVinculacionSeleccionada.codigo === 'DEUSO' && !registro.indicadorOtroVinculado && !registro.indicadorConyuge ) {
        this.navServicio.setMesage( 0, {
          severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'VINCULACIONESTADOFINANCIERO.MSG_DEBESELECCIONARCHECK' )
        } );
        this.carInformacionInicial = false;
      } else {
        this.guardar( registro );
      }
    }
  }

  guardar( registro: any ) {
    if ( registro.idVinculacionEstadoFinanciero ) {
      this.vinEstadoFinancieroServicio.actualizar( registro ).subscribe( guardado => {
        const idItem = this.lisVinculacionesEstadoFinancieroTodos.findIndex( x => x.idVinculacionEstadoFinanciero === registro.idVinculacionEstadoFinanciero );
        if ( idItem >= 0 ) {
          this.lisVinculacionesEstadoFinancieroTodos[ idItem ] = registro;
        }
        this.salir();
        this.cargarEstadosFinancieros();
        this.carInformacionInicial = false;
        this.navServicio.setMesage( 2 );
      }, error => {
        this.carInformacionInicial = false;
        this.navServicio.setMesage( 3 );
      } );
    } else {
      const exiRegistro = this.lisVinculacionesEstadoFinancieroTodos.find( x => x.idTipoVinculacion === registro.idTipoVinculacion );
      if ( exiRegistro ) {
        exiRegistro.indicadorHabilitado = registro.indicadorHabilitado;
        exiRegistro.indicadorOtroVinculado = registro.indicadorOtroVinculado;
        exiRegistro.indicadorConyuge = registro.indicadorConyuge;
        this.vinEstadoFinancieroServicio.actualizar( exiRegistro ).subscribe( guardado => {
          this.cargarEstadosFinancieros();
          this.cargarTipoVinculacion();
          this.salir();
          this.carInformacionInicial = false;
          this.navServicio.setMesage( 1 );
        } );
      } else {
        this.vinEstadoFinancieroServicio.crear( registro ).subscribe( guardado => {
          registro.idVinculacionEstadoFinanciero = guardado.idVinculacionEstadoFinanciero;
          if ( this.tipVinculacionSeleccionada ) {
            registro.codigoTipoVinculacion = this.tipVinculacionSeleccionada.codigo;
            registro.tipoVinculacion = this.tipVinculacionSeleccionada.nombre;
          }
          this.lisVinculacionesEstadoFinancieroTodos.push( registro );
          this.cargarEstadosFinancieros();
          this.cargarTipoVinculacion();
          this.salir();
          this.carInformacionInicial = false;
          this.navServicio.setMesage( 1 );
        }, error => {
          this.carInformacionInicial = false;
          this.navServicio.setMesage( 3 );
        } );
      }
    }
  }


  inhabilitar( registro: VinculacionEstadoFinanciero ) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      accept: () => {
        this.carInformacionInicial = true;
        registro.indicadorHabilitado = false;
        this.vinEstadoFinancieroServicio.actualizar( registro ).subscribe( regActualizado => {
          this.cargarEstadosFinancieros();
          this.cargarTipoVinculacion();
          this.salir();
          this.navServicio.setMesage( 2 );
          this.carInformacionInicial = false;
        } );
      },
      reject: () => {
      }
    } );
  }

  cambioTipoVinculacion( idTipo: string ) {
    this.tipVinculacionSeleccionada = this.lisVinculacionesTodos.find( x => x.idLista === idTipo );
    if ( this.tipVinculacionSeleccionada && this.tipVinculacionSeleccionada.codigo !== 'DEUSO' ) {
      this.f.indicadorOtroVinculado.setValue( false );
      this.f.indicadorConyuge.setValue( false );
    }
  }

  get f() {
    return this.formulario.controls;
  }

  editar( registro: VinculacionEstadoFinanciero ) {
    this.vinEstadoFinancieroSeleccionada = registro;
    this.cambioTipoVinculacion( this.vinEstadoFinancieroSeleccionada.idTipoVinculacion );
    this.formulario.reset();
    this.submitted = false;
    this.cargarFormulario();
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.salir();
        },
        reject: () => {
        }
      } );
    } else {
      this.salir();
    }
  }

  salir() {
    this.vinEstadoFinancieroSeleccionada = null;
    this.tipVinculacionSeleccionada = null;
    this.formulario.reset();
    this.cargarFormulario();
    this.submitted = false;
  }


}
